var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "event_icon",
    transform: "translate(20312 14138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176069",
    "data-name": "Rectangle 176069",
    width: 28,
    height: 28,
    transform: "translate(-20312 -14138)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "event",
    d: "M19.342,16.506a1.517,1.517,0,0,0-1.465,1.064l-.537,1.66H15.6a1.539,1.539,0,0,0-.9,2.785L16.1,23.041,15.564,24.7a1.539,1.539,0,0,0,2.366,1.722L19.342,25.4l1.412,1.026A1.54,1.54,0,0,0,23.124,24.7l-.539-1.661L24,22.016a1.539,1.539,0,0,0-.9-2.785H21.347l-.539-1.66a1.517,1.517,0,0,0-1.466-1.065Zm1.631,3.75h2.119a.513.513,0,0,1,.3.929L21.679,22.43a.513.513,0,0,0-.186.573l.655,2.015a.513.513,0,0,1-.79.574l-1.714-1.246a.513.513,0,0,0-.6,0l-1.714,1.246a.513.513,0,0,1-.79-.574L17.192,23a.513.513,0,0,0-.186-.573l-1.714-1.245a.513.513,0,0,1,.3-.929h2.119A.513.513,0,0,0,18.2,19.9l.655-2.015a.513.513,0,0,1,.975,0l.655,2.015a.513.513,0,0,0,.489.355Zm7.093-12.2H26.527V7.539a1.539,1.539,0,0,0-3.079,0v.513H16.776a.513.513,0,0,0,0,1.026h6.671v1.539a1.539,1.539,0,1,0,3.079,0V9.079h1.539a3.6,3.6,0,0,1,3.592,3.592v.513H8.566a.513.513,0,1,0,0,1.026H31.658v11.8a3.6,3.6,0,0,1-3.592,3.592H10.618a3.6,3.6,0,0,1-3.592-3.592V12.671a3.6,3.6,0,0,1,3.592-3.592h1.539v1.539a1.539,1.539,0,1,0,3.079,0V7.539a1.539,1.539,0,1,0-3.079,0v.513H10.618A4.624,4.624,0,0,0,6,12.671V26.013a4.624,4.624,0,0,0,4.618,4.618H28.066a4.624,4.624,0,0,0,4.618-4.618V12.671a4.624,4.624,0,0,0-4.618-4.618ZM25.5,10.618a.513.513,0,1,1-1.026,0V7.539a.513.513,0,1,1,1.026,0ZM13.184,7.539a.513.513,0,1,1,1.026,0v3.079a.513.513,0,1,1-1.026,0Z",
    transform: "translate(-20317.375 -14142)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/event_icon.12ce2d0aa117c5727e1a25841d7c7344.svg";
export { ForwardRef as ReactComponent };